import { registerWidget } from '@/widget-mount.js';
import LogoCarousel from './index.vue';
import '@/style.css';

registerWidget('logo-carousel', LogoCarousel);
